import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Template from "../../template/Template";
import TableDataSimple from "../../components/Tables/TableDataSimple";
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api } from '../../services/api';
import isPermission from '../../services/permission';

export default function Usuarios() {
    const [infoLogin] = useState(JSON.parse(sessionStorage.getItem('infoLogin')));
    const [openLoad, setOpenLoad] = useState(false);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const columns = [
        {
            id: 'nome_usuario',
            numeric: false,
            label: 'USUARIO',
        },
        {
            id: 'email_usuario',
            numeric: false,
            disablePadding: false,
            label: 'EMAIL',
        },
        {
            id: 'telefone_usuario',
            numeric: false,
            disablePadding: false,
            label: 'TELEFONE',
        }
    ];

    function handleClick(row) {
        if(isPermission(3) && row.id_usuario){
            navigate(`/cadastrousuario?id=${row.id_usuario}`);
        }
    }

    async function loadData() {
        setOpenLoad(true);
        const {id_escola_usuario} = infoLogin;
        try {
            const response = await api.post(`/usuarios`, {id_escola_usuario});
            if(response && response.status === 200 && response.data){
                if(response.data.error) AlertInfo("error", response.data.message);
                else setRows(response.data);
            }
        } catch (error) {
            console.log(error);
            AlertInfo("error", 'NÃO POSSIVEL BUSCAR DADOS');
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, []);

    return(
        <Template menuActive="usuarios">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={2}>
                    {isPermission(2) && (
                        <Link to="/cadastrousuario">
                            <Button 
                                variant="contained"
                                fullWidth
                            >
                                NOVO USUARIO
                            </Button>
                        </Link>
                    )}
                </Grid>
                <Grid item xs={12}>
                    <TableDataSimple
                        label="Lista de Usuarios"
                        rows={rows}
                        columns={columns} 
                        handleClick={handleClick}
                    />
                </Grid>
            </Grid>

            <SimpleBackdrop open={openLoad} />
        </Template>
    );
}